import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  addHtmlRootEventListener,
  getHtmlElement,
  isValidCap,
  isValidCity,
  isValidCountry,
  isValidFirstName,
  isValidLastName,
  isValidNumber,
  isValidProvince,
  isValidStreetSquare,
  isValidUserAddress,
  removeHtmlChildren,
  removeHtmlElementClass,
  renderWebComponent,
  setHtmlElementContent,
  setHtmlElementValue,
  string2obj,
  checkHtmlElement,
  parseShipmentAddress,
  appendHtmlElementChild,
  isValidPhoneNumber,
  isValidAddressEmail,
  isDefined,
  EMPTY_ADDRESS
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";
import I18n from "i18n-js";


export class SubmissionListAddressesModalComponent extends HTMLElement {
  props = {};
  modal = null;
  newAddress = {};
  emptyAddress = EMPTY_ADDRESS;
  selectedAddressId = null

  static get observedAttributes() {
    return ['props'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.emptyAddress.email = this.props.currentUserEmail;
    this.newAddress = {
      ...this.emptyAddress,
      submission_list_id: this.props.submissionList.id
    }
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.eventBus = EventBusComponent.getInstance();
  }


  connectedCallback() {
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => {
      this.updateSubmissionListState(submissionList)
    });

    const modal = getHtmlElement(this.shadowRoot, 'addressModal')
    this.eventBus.subscribe('open-submission-list-addresses-modal', (props) => setTimeout(() => this.openModal(props), 1))

    addHtmlElementEventListener(this.shadowRoot, 'closeButton1', 'click', () => modal.classList.remove("show"));
    addHtmlElementEventListener(this.shadowRoot, 'closeButton2', 'click', () => modal.classList.remove("show"));
    addHtmlRootEventListener(window, 'keydown', (e) => {
      if (e.key === "Escape") {
        modal.classList.remove("show");
      }
    })

    // window.top.document.addEventListener("click", function(e) {
    //   if (!modal.contains(e.target)) {
    //     modal.classList.remove("show");
    //   }
    // });
    Object.keys(this.emptyAddress).forEach(key => {
      if (key !== 'residence')
        addHtmlElementEventListener(this.shadowRoot, key, ['country_id', 'province'].includes(key) ? 'change' : 'input', (e) => this.setNewAddress(key, e.target.value));
      else
        addHtmlElementEventListener(this.shadowRoot, key, 'change', () => this.newAddress['residence'] = !this.newAddress['residence']);
    });

    addHtmlElementEventListener(this.shadowRoot, 'confirmButton', 'click', () => this.handleConfirm());
    addHtmlElementEventListener(this.shadowRoot, 'new-address-add', 'click', () => this.handleOpenNewAddress());
    addHtmlElementEventListener(this.shadowRoot, 'close-new-address-button', 'click', () => this.handleCloseNewAddress());
  }



  // Funzione che gestisce l'apertura della modale che permette all'utente / aggregatore di specificare un indirizzo
  openModal(props) {
    this.selectedAddressId = null;
    this.props.address_type = props.address_type;
    setHtmlElementContent(this.shadowRoot, 'title', I18n.t(`js.newUserAddressForm.title`))

    if (props.addresses?.length > 0) {
      removeHtmlElementClass(this.shadowRoot, 'old-addresses', 'd-none')
      addHtmlElementClass(this.shadowRoot, 'new-address-add', 'cursor-pointer')
      this.selectedAddressId = this.props.submissionList[`${this.props.submissionList.created_by}_${this.props.address_type}_address_id`];
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'list-addresses'))
      addHtmlElementClass(this.shadowRoot, 'close-new-address-button', 'd-none')
      addHtmlElementClass(this.shadowRoot, 'new-address-section', 'd-none')
      for (let i = 0; i < props.addresses.length; i++)
        this.addAddress(props.addresses[i], i);
    } else {
      addHtmlElementClass(this.shadowRoot, 'old-addresses', 'd-none')
      removeHtmlElementClass(this.shadowRoot, 'new-address-add', 'cursor-pointer')
      this.handleOpenNewAddress();
    }

    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'country_id'));
    const filteredCountries = {}
    for (const countryId of Object.keys(this.props.countries))
      if (this.props.submissionList.grader_company.countries_ids_for_shipments[this.props.address_type].includes(parseInt(countryId)))
        filteredCountries[countryId] = this.props.countries[countryId];
    const countriesSelectOptions = document.createElement('template');
    countriesSelectOptions.innerHTML = `
      <option id="empty_country" value="">
        ${I18n.t('js.newUserAddressForm.countryPlaceholder')}
      </option>
      ${Object.entries(filteredCountries)
        .sort(([countryId1, countryData1], [countryId2, countryData2]) => countryData1.name < countryData2.name ? -1 : 0)
        .map(([countryId, countryData]) =>
          `<option value=${countryId}>
              ${countryData.name}
            </option>`
        ).join('')
      }
    `
    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'country_id'), countriesSelectOptions.content.cloneNode(true));

    addHtmlElementClass(this.shadowRoot, "addressModal", "show");
    this.clearForm();
    setHtmlElementValue(this.shadowRoot, 'email', this.emptyAddress.email);
  }


  // Funzione che pulisce la form di creazione di un nuovo indirizzo sulla modale
  clearForm() {
    Object.keys(this.emptyAddress).forEach(key => {
      removeHtmlElementClass(this.shadowRoot, key, 'border-red-imp');
      setHtmlElementValue(this.shadowRoot, key, '');
    });
    checkHtmlElement(this.shadowRoot, 'residence', false);
  }

  handleOpenNewAddress() {
    this.selectedAddressId = null;
    removeHtmlElementClass(this.shadowRoot, 'close-new-address-button', 'd-none');
    removeHtmlElementClass(this.shadowRoot, 'new-address-section', 'd-none');
    const matches = this?.shadowRoot?.querySelectorAll('[id^="address_"]');
    matches.forEach(el => {
      const input = el.querySelector('input');
      if (input) { 
        input.disabled = true;
        input.checked = false;
      }
    });
  }

  handleCloseNewAddress() {
    addHtmlElementClass(this.shadowRoot, 'close-new-address-button', 'd-none');
    addHtmlElementClass(this.shadowRoot, 'new-address-section', 'd-none');
    const matches = this?.shadowRoot?.querySelectorAll('[id^="address_"]');
    matches.forEach(el => {
      const input = el.querySelector('input');
      if (input && !input.classList.contains('not-available-country')) {
        input.disabled = false;
      }
    });
  }



  // Funzione che aggiunge all'interfaccia grafica un nuovo indirizzo dell'utente / aggregatore che egli può scegliere
  // come indirizzo per il ritiro del pacco a domicilio / ritorno dei suoi prodotti una volta gradati
  addAddress(address) {
    const shipmentAvailableByCountry = this.props.submissionList.grader_company.countries_ids_for_shipments[this.props.address_type].includes(address.country_id);
    const shipmentAvailableByProvince = shipmentAvailableByCountry && this.props.countries[address.country_id]['provinces'].includes(address.province);

    const row = document.createElement('template');
    row.innerHTML = `
      <div id=${'address_' + address.id} 
           class="row px-4 pt-3 w-100 w-100 text-left custom-control custom-radio">
        <input
          type="radio"
          id=${'input_address_' + address.id}
          name=${'input_address_' + address.id}
          value=${address.id}
          class="aiG-radio custom-control-input  ${!shipmentAvailableByCountry || !shipmentAvailableByProvince ? 'not-available-country' : ''}"
          ${!shipmentAvailableByCountry || !shipmentAvailableByProvince ? 'disabled' : ''}
        />
        <label
          class="aiG-label-radio custom-control-label"
          id=${"label_address_" + address.id}
          for=${'input_address_' + address.id}
        > 
          ${address.residence ? `
            <b>${I18n.t('js.newUserAddressForm.residenceCompact')}</b>
            <br/>
          ` : ''}
          ${parseShipmentAddress(address)}
          ${!shipmentAvailableByCountry || !shipmentAvailableByProvince ? `
            <br/>
            <b>${I18n.t(`js.editSubmissionListPage.webComponent.draft.${this.props.address_type}NotAvailableOnThis${!shipmentAvailableByCountry ? 'Country' : 'Province'}`)}</b>
          ` : ''}
        </label>
      </div>
    `
    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'list-addresses'), row.content.cloneNode(true));

    if (this.selectedAddressId)
      checkHtmlElement(this.shadowRoot, `input_address_${this.selectedAddressId}`, true);

    addHtmlElementEventListener(this.shadowRoot, `input_address_${address.id}`, 'change', () => this.handleChangeAddress(address.id))
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList };
    this.handleNewAddressLinkRendering();
  }


  // Funzione che si occupa di settare i vari parametri del nuovo indirizzo che l'utente sta impostando
  // per richiedere il ritiro a domicilio del pacco / ricevere indietro i suoi prodotti una volta gradati
  setNewAddress(key, value) {
    const val = value?.replaceAll('#_#', ' ')
    this.newAddress[key] = val;
    if (key === 'country_id') {
      if (isDefined(val) && isDefined(this.props.countries[val])) {
        this.newAddress['country'] = this.props.countries[val].name;
        const provincesByCountry = this.props.countries[val].provinces;
        this.props.provinces = provincesByCountry;
        if (isDefined(this.newAddress['province']) && !provincesByCountry?.includes(this.newAddress['province']))
          this.newAddress['province'] = '';
      }
      else {
        this.props.provinces = [];
        this.newAddress['province'] = '';
      }

      const options = document.createElement('template');
      let optionsContent = `
      <option id="empty_province" value="">
        ${I18n.t('js.newUserAddressForm.provincePlaceholder')}
      </option>`;
      let firstCategory = null;
      for (const province of this.props.provinces) {
        optionsContent = optionsContent +
          `<option value=${province.replaceAll(' ', '#_#')}>
            ${province}
          </option>`;
      }

      options.innerHTML = optionsContent;
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'province'))
      appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'province'), options.content.cloneNode(true));
    }
  }


  // Funzione che gestisce il cambio di un indirizzo già esistente dell'utente / aggregatore che egli può scegliere
  // come indirizzo per il ritiro del pacco a domicilio / ritorno dei suoi prodotti una volta gradati
  handleChangeAddress(newAddressId) {
    if (this.props.submissionList.addresses)
      for (const address of this.props.submissionList.addresses)
        if (address.id !== newAddressId)
          checkHtmlElement(this.shadowRoot, `input_address_${address.id}`, false);
    this.selectedAddressId = newAddressId;
  }


  // Funzione che gestisce la conferma finale dell'indirizzo scelto dall'utente / aggregatore per il ritiro del pacco a
  // domicilio / riconsegna di ritorno dei suoi prodotti una volta gradati
  handleConfirm() {
    // In questo ramo gestisco la scelta dell'utente / aggregatore di usare uno dei suoi indirizzi già esistenti
    if (this.selectedAddressId) {
      const url = `/submission_lists/${this.props.submissionList.id}`;

      const body = {};
      body[`${this.props.submissionList.created_by}_${this.props.address_type}_address_id`] = this.selectedAddressId;

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((submissionList) => {
          this.closeModal(submissionList);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.eventBus.publish('render-modal', { error: true });
        });
    }
    // In questo ramo gestisco la scelta dell'utente / aggregatore di usare un nuovo indirizzo appena creato
    else if (isValidUserAddress(this.newAddress)) {
      const url = `/users/${this.props.submissionList[`${this.props.submissionList.created_by}_id`]}/shipment_addresses`;

      this.clearForm();

      if (this.props.submissionList.addresses?.length === 0)
        this.newAddress['is_default'] = 'default'

      this.newAddress['address_type'] = this.props.address_type

      fetch(url + ".json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.newAddress),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during saving data on the database");
          else
            return response.json();
        })
        .then((submissionList) => {
          this.closeModal(submissionList);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          this.eventBus.publish('render-modal', { error: true });
        });
    } else {
      if (!isValidFirstName(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'first_name', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'first_name', 'border-red-imp')
      if (!isValidLastName(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'last_name', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'last_name', 'border-red-imp')
      if (!isValidCountry(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'country_id', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'country_id', 'border-red-imp')
      if (!isValidCity(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'city', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'city', 'border-red-imp')
      if (!isValidProvince(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'province', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'province', 'border-red-imp')
      if (!isValidStreetSquare(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'street_square', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'street_square', 'border-red-imp')
      if (!isValidNumber(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'number', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'number', 'border-red-imp')
      if (!isValidCap(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'cap', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'cap', 'border-red-imp')
      if (!isValidPhoneNumber(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'phone_number', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'phone_number', 'border-red-imp')
      if (!isValidAddressEmail(this.newAddress))
        addHtmlElementClass(this.shadowRoot, 'email', 'border-red-imp')
      else
        removeHtmlElementClass(this.shadowRoot, 'email', 'border-red-imp')
    }
  }



  // Funzione che gestisce la chiusura della modale che permette all'utente / aggregatore di specificare un indirizzo
  closeModal(newSubmissionList) {
    if (newSubmissionList) {
      this.eventBus.publish("updated-submission-list-state", newSubmissionList);
      this.eventBus.publish("render-new-success-flash-message");
    }

    this.newAddress = {
      ...this.emptyAddress,
      submission_list_id: this.props.submissionList.id
    }
    this.setNewAddress('country_id', null);

    removeHtmlElementClass(this.shadowRoot, 'addressModal', 'show');
  }


  // Funzione che discrimina se renderizzare o meno "nuovo indirizzo" che permette all'utente di
  // create un nuovo indirizzo a cui effettuare il ritiro del pacco a domicilio / la consegna di ritorno a domicilio
  handleNewAddressLinkRendering() {
    if (this.props.submissionList.is_middleman_for_company) {
      addHtmlElementClass(this.shadowRoot, 'new-address-container', 'd-none');
    } else {
      removeHtmlElementClass(this.shadowRoot, 'new-address-container', 'd-none');
    }
  }



  render() {
    const html = `      
      <div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle">
        <div class="modal-dialog modal-lg" role="document" id="modalContainer">
          <div class="modal-content">
            <div class="modal-header" id="header">
              <h5 class="modal-title" id="title"></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeButton1">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body" id="body">
              <div class="">
                <div class="mb-4" id="old-addresses">
                  <div class="px-4 mt--8px-imp">
                    <fieldset id="list-addresses" class="w-100"></fieldset>
                  </div>
                </div>
                
                
                <div id="new-address-container">
                  <div class="row mx-0" id="new-address">
                    <div class="col-10 text-left font-size-1rem" id="new-address-add">
                      <b class="cursor-pointer text-blue">${I18n.t('js.newUserAddressForm.title_use_new_address')}</b>
                    </div>
                    <div class="col-2 text-right" id="new-address-arrow">
                      <h5 class="m-0 p-0">
                       <div type="button" class="close" id="close-new-address-button">                
                          <span>&times;</span>
                        </div>
                      </h5>
                    </div>
                  </div>
                  
                  <div class="row mx-0 mt--8px-imp" id="new-address-section">
                    <div class="col-12 col-md-6 mt-3">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.firstName')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="first_name"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.firstNamePlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 col-md-6 mt-3">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.lastName')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="last_name"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.lastNamePlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.co')}</span></p>
                      <input
                        type="text"
                        id="co"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.coPlaceholder')}"
                      />
                    </div>
                    
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.country')}<sup>*</sup></span></p>
                      <select 
                        class="form-control address-input h-35px"
                        name="country_id" 
                        id="country_id"
                      >
                      </select>
                    </div>
          
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.province')}<sup>*</sup></span></p>
                      <select 
                        class="form-control address-input h-35px"
                        name="province" 
                        id="province"
                      >
                      </select>
                    </div>
                    
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.city')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="city"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.cityPlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.postalCode')}<sup>*</sup></span></p>
                      <input
                        type="number"
                        id="cap"
                        class="form-control address-input h-35px hide-arrows-number"
                        placeholder="${I18n.t('js.newUserAddressForm.postalCodePlaceholder')}"
                      />
                    </div>
                    
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.street')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="street_square"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.streetPlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.number')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="number"
                        class="form-control address-input h-35px hide-arrows-number"
                        placeholder="${I18n.t('js.newUserAddressForm.numberPlaceholder')}"
                      />
                    </div>
                    
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.indoor')}</span></p>
                      <input
                        type="text"
                        id="indoor"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.indoorPlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.phoneNumber')}<sup>*</sup></span></p>
                      <input
                        type="number"
                        id="phone_number"
                        class="form-control address-input h-35px hide-arrows-number"
                        placeholder="${I18n.t('js.newUserAddressForm.phoneNumberPlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 col-md-6 mt-2">
                      <p class="mb-0"><span>${I18n.t('js.newUserAddressForm.email')}<sup>*</sup></span></p>
                      <input
                        type="text"
                        id="email"
                        class="form-control address-input h-35px"
                        placeholder="${I18n.t('js.newUserAddressForm.emailPlaceholder')}"
                      />
                    </div>
          
                    <div class="col-12 mt-4 d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="residenceCheckbox cursor-pointer mb-2"
                        id="residence"
                      />
                      &nbsp;
                      &nbsp;
                      <label class="ml-1 mb-0 cursor-pointer font-weight--normal" for="residence">
                        ${I18n.t('js.newUserAddressForm.residence')}<br/>
                        <small>${I18n.t('js.newUserAddressForm.residenceExplanation')}</small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
            <button
              type="button"
              class="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized h-40px-imp"
              data-dismiss="modal" id="closeButton2"
            >
              ${I18n.t('js.common.button.cancel').toUpperCase()}
            </button>
            <button
              type="button"
              id="confirmButton"
              class="btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
            >
              ${I18n.t('js.common.button.confirm').toUpperCase()}
            </button>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, styles, submissionListsStyles]);
    this.handleNewAddressLinkRendering();
    this.setNewAddress('country_id', null);
  }
}

window.customElements.define("submission-list-addresses-modal-component", SubmissionListAddressesModalComponent);